import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ic-check_ba0de9504f393dabae5259cb8b84f903",
  "use": "ic-check_ba0de9504f393dabae5259cb8b84f903-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"ic-check_ba0de9504f393dabae5259cb8b84f903\">\n<path d=\"M9.00016 16.1698L4.83016 11.9998L3.41016 13.4098L9.00016 18.9998L21.0002 6.99984L19.5902 5.58984L9.00016 16.1698Z\" fill=\"#294155\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol